module.exports = __webpack_public_path__ + "static/media/bariol_bold.ff6d057ec95b6df4703a4dc4bb401b119124c019d05f372f4f60eda0c80c276c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bariol_bold.ttf
// module id = 2545
// module chunks = 204